import { useEffect, useRef } from "react";
import {
  Swiper as SwiperComponent,
  SwiperRef,
  SwiperProps as SwiperComponentProps,
} from "swiper/react";
import { type Swiper as SwiperType } from "swiper/types";

interface SwiperProps extends SwiperComponentProps {
  children: React.ReactNode;
  onChangeSlide?: (swiper: SwiperType) => void;
}

export const Swiper = ({ children, onChangeSlide, ...props }: SwiperProps) => {
  const ref = useRef<SwiperRef>(null);

  useEffect(() => {
    if (!ref.current?.swiper) return;

    const swiper = ref.current.swiper;

    if (onChangeSlide) {
      swiper.on("slideChange", onChangeSlide);
    }

    return () => {
      if (onChangeSlide) {
        swiper.off("slideChange", onChangeSlide);
      }
    };
  }, [ref, onChangeSlide]);

  return (
    <SwiperComponent ref={ref} {...props}>
      {children}
    </SwiperComponent>
  );
};
